import React from 'react'
import { supportedLanguages } from '../../i18n'

import Layout from "../layouts/pt"
import SEO from '../components/seo'
import RegisterWizard from '../components/RegisterWizard/RegisterWizard'

const TestarPlataformaPage = (props) => {
  return (
    <Layout fullScreen={false} location={props.location}>
      <SEO 
        title={"Cadastro para testar nossa plataforma - WePayOut"}
        description="Precisa fazer pagamentos a um número grande de beneficiários? Com uma transferência, podemos fazer o restante do trabalho para você via PIX ou transferência bancária."
        meta={[{ name: 'keywords', content: 'testar plataforma, teste, fintech, wepayout' }]}
        additionalBreadcrumb={{
          url: 'https://wepayout.co/pt-br/testar-plataforma',
          title: 'Cadastro para testar nossa plataforma'
        }}
        path="https://wepayout.co/pt-br/testar-plataforma">
        {Object.keys(supportedLanguages).map((lang, index) => <link key={index} rel="alternate" href={`https://wepayout.co${lang !== 'en' ? ('/' + lang) : ''}`} hreflang={lang} />)}
        <link rel="alternate" href="https://wepayout.co" hreflang="x-default" />
      </SEO>
      <RegisterWizard />
    </Layout>
  )
}

export default TestarPlataformaPage